import React, { FunctionComponent } from 'react';
import style from './styles.module.scss';

interface IProps {
  children: React.ReactNode;
}

const NavButtons: FunctionComponent<IProps> = ({ children }) => <div className={style.NavButtons}>{children}</div>;

export default NavButtons;
